<template>
    <FloatingPanel title="Goedgekeurde initiatieven">
        <div class="initiatief::canvas-blocks-modules-initiatieven-BlockPanel">
            <Tabs :tabs="['Maatwerk', 'Algemeen']">
                <div slot="Maatwerk">
                    <NumberInput
                        label="Aantal initiatieven"
                        instruction="Het aantal initiatieven dat getoond wordt."
                        :options="options"
                        options-property="pagination"
                        :min-val="1"
                        placeholder="3"
                        :open="true"
                        @valueChange="save()"
                    />
                </div>
                <div slot="Algemeen">
                    <CommonInputs :options="options"/>
                </div>
            </Tabs>
        </div>
    </FloatingPanel>
</template>

<script>
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import NumberInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/NumberInput";

export default {
    extends: AbstractPanel,
    components: { FloatingPanel, CommonInputs, Tabs, NumberInput },
}
</script>

<style lang="scss" scoped>
.initiatief\:\:canvas-blocks-modules-initiatieven-BlockPanel { }
</style>
